module.exports = __webpack_public_path__ + "img/modal-view.db989579.png";